import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-rating-buttons',
  template: `
    <div class="mb-3">
      <div class="mb-2">
        {{ props.label }}
        <span *ngIf="props.required" class="text-danger">*</span>
      </div>
      <p *ngIf="props.description" class="small text-muted mb-2">
        {{ props.description }}
      </p>

      <div class="d-flex rating-container">
        <button
          *ngFor="
            let num of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
            let isFirst = first;
            let isLast = last
          "
          type="button"
          class="p-0 rating-btn"
          [class.active]="formControl.value === num"
          [class.first-btn]="isFirst"
          [class.last-btn]="isLast"
          (click)="setValue(num)"
        >
          {{ num }}
        </button>
      </div>
    </div>

    <div *ngIf="showError" class="text-danger small mt-1">
      <formly-validation-message [field]="field"></formly-validation-message>
    </div>
  `,
  styles: [
    `
      .rating-btn {
        border: 1px solid #dee2e6;
        border-radius: 0 !important;
        text-decoration: none;
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: none;
        border-left: none;
        position: relative;
        font-weight: 500;
        color: #495057;
        transition: none !important;
        background: #fff;
        width: 100%;
        font-weight: bold;
        font-size: 16px;
        font-weight: 400;

        &:hover::after {
          display: none !important;
        }

        &::after {
          content: '';
          position: absolute;
          right: 0;
          top: 20%;
          bottom: 20%;
          width: 1px;
          background: #dee2e6;
        }

        &.first-btn {
          border-radius: 50px 0 0 50px !important;
          border-left: 1px solid #dee2e6;
        }

        &.last-btn {
          border-radius: 0 50px 50px 0 !important;
          border-right: 1px solid #dee2e6;

          &::after {
            display: none;
          }
        }

        &:hover {
          background-color: var(--color-primary-light);
          border-top-color: var(--color-primary-light);
          border-bottom-color: var(--color-primary-light);
          color: white;

          &.first-btn {
            border-left-color: var(--color-primary-light);
          }

          &.last-btn {
            border-right-color: var(--color-primary-light);
          }

          &::after {
            background: var(--color-primary-light);
          }
        }

        &.active {
          background-color: var(--color-primary);
          border-top-color: var(--color-primary);
          border-bottom-color: var(--color-primary);
          color: white;

          &.first-btn {
            border-left-color: var(--color-primary);
          }

          &.last-btn {
            border-right-color: var(--color-primary);
          }

          &::after {
            background: var(--color-primary);
          }
        }
      }
    `,
  ],
  standalone: false,
})
export class RatingButtonsType extends FieldType {
  setValue(value: number) {
    this.formControl.setValue(value);
    this.formControl.markAsTouched();
  }
}